const track = function() {
	const exists = () =>
		// eslint-disable-next-line no-undef
		typeof ga === "function" && ga.getAll === "function"

	const send = data => {
		if (!exists) {
			return
		}

		console.log(`ga('send', 'event', ${data.eventCategory}, ${data.eventAction}, ${data.eventLabel});`);

		// eslint-disable-next-line no-undef
		ga("send", "event", data.eventCategory, data.eventAction, data.eventLabel);
	}

	return {
		send,
	}
}

export default track